import { FC } from 'react'

type ChevronDownEmptyIconProps = {
  className?: string
}

const ChevronDownEmptyIcon: FC<ChevronDownEmptyIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 0.75L6 5.25L10.5 0.75"
        stroke="#2B2F33"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChevronDownEmptyIcon
